import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/button';
import ContactFormModal from './ContactFormModal';

const HeroSection = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);

  return (
    <>
      <section className="relative bg-gradient-to-br from-slate-50 via-white to-[#032a60]/10 py-20 overflow-hidden">
        {/* Decorative background pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-10 left-10 w-32 h-32 border-4 border-[#032a60] rounded-lg"></div>
          <div className="absolute bottom-20 left-1/4 w-24 h-24 border-4 border-[#d28f28] rounded-lg"></div>
          <div className="absolute top-1/3 right-20 w-28 h-28 border-4 border-[#032a60] rounded-lg"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left content */}
            <div className="space-y-8">
              <div>
                <h2 className="text-5xl md:text-6xl font-bold leading-tight">
                  <span className="text-[#032a60]">Secure, Private</span>
                  <br />
                  <span className="text-gray-900">Email for Modern Professionals</span>
                </h2>
              </div>

              <div className="space-y-4">
                <div className="flex items-start gap-3 group transition-transform duration-300 hover:translate-x-2">
                  <Check className="h-6 w-6 text-[#d28f28] mt-1 flex-shrink-0" strokeWidth={3} />
                  <p className="text-lg text-gray-700">
                    Protect your communication with Vaulted Mails, a fully encrypted and privacy-focused email platform
                  </p>
                </div>

                <div className="flex items-start gap-3 group transition-transform duration-300 hover:translate-x-2">
                  <Check className="h-6 w-6 text-[#d28f28] mt-1 flex-shrink-0" strokeWidth={3} />
                  <p className="text-lg text-gray-700">
                    Operate your business email on a secure, privacy-first, completely tracker-free environment
                  </p>
                </div>

                <div className="flex items-start gap-3 group transition-transform duration-300 hover:translate-x-2">
                  <Check className="h-6 w-6 text-[#d28f28] mt-1 flex-shrink-0" strokeWidth={3} />
                  <p className="text-lg text-gray-700">
                    End surveillance, data harvesting, and inbox tracking permanently
                  </p>
                </div>
              </div>
            </div>

            {/* Right illustration */}
            <div className="relative">
              <div className="relative z-10">
                <img
                  src="/assets/banner-img.png"
                  alt="Secure Email Protection"
                  className="w-full h-auto drop-shadow-2xl"
                />
              </div>
              
              {/* Background glow effect */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-[#032a60] rounded-full filter blur-3xl opacity-20 animate-pulse" style={{ animationDuration: '4s' }}></div>
            </div>
          </div>
        </div>
      </section>

      <ContactFormModal 
        isOpen={isContactOpen} 
        onClose={() => setIsContactOpen(false)}
        title="Get Started with Vaulted Mails"
      />
    </>
  );
};

export default HeroSection;